import { Component, Input, OnInit } from '@angular/core';
import { SmsModel } from '../../models/sms.model';
import { SmsService } from '../../services/sms.service';

@Component({
    selector   : 'my-sms',
    template: require('./sms.component.html'),
    styles: [require('./sms.component.scss')],
})

export class SmsComponent implements OnInit{

    @Input('sms') sms:SmsModel;
    state: boolean = false;

    predefinedMessage: any = [
        {title: 'Service terminé', text: 'Bonjour,\n' +
        'Le service de votre vélo est terminé.\n' +
        'Rochat Cycles'},
        {title: 'Vélo neuf terminé', text: 'Bonjour,\n' +
        'Votre nouveau vélo est prêt et vous attend !\n' +
        'Rochat Cycles'},
        {title: 'Pièces commandées reçues', text: 'Bonjour,\n' +
        'Votre commande de pièces est à disposition.\n' +
        'Rochat Cycles'},
        {title: 'Horaires du magasin - Aubonne', text: 'Mar-Ven: 09:30-12:00,14:00-19:00\n' +
        'Sam: 08:00-17:00'},
        {title: 'Horaires du magasin - Genève', text: 'Mar-Ven: 10:00-14:00,15:00-19:00\n' +
        'Sam: 12:00-17:00'}
    ];

    constructor(private smsService:SmsService) {

    }

    ngOnInit(){
        if (this.sms.mobile.length == 13 && this.sms.mobile.substr(0, 4) == '0041')
            this.sms.mobile = '0' + this.sms.mobile.substr(4, 9);
        if (this.sms.from == 'service') {
            this.addPredefinedMessage(this.predefinedMessage[0].text);
        }
    }

    addPredefinedMessage(text){
        if (this.sms.message.length == 0){
            this.sms.message = text;
        } else if (this.sms.message.substr(-1, 1) == ' ' || this.sms.message.substr(-1, 1) == '\n') {
            this.sms.message = this.sms.message + '' + text;
        } else {
            this.sms.message = this.sms.message + ' ' + text;
        }
        this.sms.calculatePrice();
    }

    send(){
        if (this.smsService.isSend || this.smsService.state)
            return ;
        else
            this.sms.send();
    }

    close(){
        this.smsService.openPanel = false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/sms/sms.component.ts